"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("./models/icons/icons");
const d3_hypertree_1 = require("d3-hypertree");
const d3_hypertree_2 = require("d3-hypertree");
const d3_hypertree_3 = require("d3-hypertree");
const d3_hypertree_4 = require("d3-hypertree");
const d3_hypertree_5 = require("d3-hypertree");
const d3_hypertree_6 = require("d3-hypertree");
const d3_hypertree_7 = require("d3-hypertree");
const d3_hypertree_8 = require("d3-hypertree");
const d3_hypertree_9 = require("d3-hypertree");
//export * as hyt from 'd3-hypertree'
exports.layouts = { layoutBergé: d3_hypertree_5.layoutBergé, layoutBuchheim: d3_hypertree_6.layoutBuchheim, layoutSpiral: d3_hypertree_7.layoutSpiral, layoutUnitVectors: d3_hypertree_8.layoutUnitVectors, layoutUnitLines: d3_hypertree_9.layoutUnitLines };
exports.loaders = { fromFile: d3_hypertree_3.fromFile, fromLangFile: d3_hypertree_4.fromLangFile, generators: d3_hypertree_2.generators };
exports.options = { presets: d3_hypertree_1.presets, loaders: exports.loaders, layouts: exports.layouts, iconmap: new icons_1.Icons() };
var icons_2 = require("./models/icons/icons");
exports.Icons = icons_2.Icons;
var d3_hypertree_10 = require("d3-hypertree");
exports.Hypertree = d3_hypertree_10.Hypertree;
var d3_hypertree_11 = require("d3-hypertree");
exports.HypertreeEx = d3_hypertree_11.HypertreeEx;
var navigation_1 = require("./components/navigation/navigation");
exports.Navigation = navigation_1.Navigation;
var model_1 = require("./models/navigation/model");
exports.OtolSetModel = model_1.OtolSetModel;
var model_2 = require("./models/navigation/model");
exports.NavigationModel = model_2.NavigationModel;
var navigation2_1 = require("./components/navigation/navigation2");
exports.Navigation2 = navigation2_1.Navigation2;
var splitter_1 = require("./components/splitter/splitter");
exports.Splitter = splitter_1.Splitter;
var primitive_1 = require("./components/primitive");
exports.WikiUi = primitive_1.WikiUi;
var primitive_2 = require("./components/primitive");
exports.StringUi = primitive_2.StringUi;
var model_3 = require("./models/navigation/model");
exports.alllanguages = model_3.alllanguages;
window.app = {};
exports.initpromise = {
    'eukaryota': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .25 }, null))
        .then(() => t.api.gotoλ(.08))
        .then(() => t.drawDetailFrame()),
    'metazoa': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.07))
        .then(() => t.drawDetailFrame()),
    'insecta': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .35 }, null))
        .then(() => t.api.gotoλ(.15))
        .then(() => t.drawDetailFrame()),
    'hymenoptera': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.15))
        .then(() => t.drawDetailFrame()),
    'lophotrochozoa': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.22))
        .then(() => t.drawDetailFrame()),
    'araneae': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.4))
        .then(() => t.drawDetailFrame()),
    'embryophyta': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .65 }, null))
        .then(() => t.api.gotoλ(.1))
        .then(() => t.drawDetailFrame()),
    'chondrichthyes': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .4 }, null))
        .then(() => t.api.gotoλ(.25))
        .then(() => t.drawDetailFrame()),
    'tetrapoda': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.1))
        .then(() => t.drawDetailFrame()),
    'vertebrata': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.1))
        .then(() => t.drawDetailFrame()),
    'mammalia': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .3 }, null))
        .then(() => t.api.gotoλ(.2))
        .then(() => t.api.goto({ re: 0, im: .7 }, null))
        .then(() => t.drawDetailFrame()),
    'laurasiatheria': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: .05, im: .3 }, null))
        .then(() => t.api.gotoλ(.32))
        .then(() => t.drawDetailFrame()),
    'carnivora': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.2))
        .then(() => t.drawDetailFrame()),
    'primates': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.22))
        .then(() => t.drawDetailFrame()),
    'sciuridae': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.15))
        .then(() => t.drawDetailFrame()),
    'metatheria': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: 0, im: .5 }, null))
        .then(() => t.api.gotoλ(.15))
        .then(() => t.drawDetailFrame()),
    'aves': (p, t) => p
        .then(() => new Promise((ok, err) => t.animateUp(ok, err)))
        .then(() => t.api.goto({ re: .03, im: .73 }, null))
        .then(() => t.api.gotoλ(.1))
        .then(() => t.drawDetailFrame()),
};



//////////////////
// WEBPACK FOOTER
// ./dist/js/index.js
// module id = 417
// module chunks = 0